import type { paths } from '@cou/contracts';
import { adminApi, type ApiFailure } from '../api/admin-api';

/*
 * The settlement metrics client (API-24, admin-ui.md → Settlement › Monitoring strip). Counts, not
 * rows: the queues themselves are API-11 (corrections) and API-23 (failed awards).
 */

export type SettlementMetrics =
  paths['/api/admin/settlement/metrics']['get']['responses'][200]['content']['application/json'];

export type GetMetricsResult = { ok: true; metrics: SettlementMetrics } | ApiFailure;

/** The monitoring strip's counts, optionally scoped to one Contest (API-24 GET). */
export async function getSettlementMetrics(
  adminToken: string,
  contestId?: string,
): Promise<GetMetricsResult> {
  const result = await adminApi.get<SettlementMetrics>(
    adminToken,
    '/api/admin/settlement/metrics',
    { contestId },
  );
  if (!result.ok) return result;
  const { ok: _ok, ...metrics } = result;
  return { ok: true, metrics };
}

export interface MetricsClient {
  getSettlementMetrics(adminToken: string, contestId?: string): Promise<GetMetricsResult>;
}

export const defaultMetricsClient: MetricsClient = { getSettlementMetrics };
